import React from 'react';
import './signup_phone_modal.scss';
import { FormattedMessage } from 'react-intl';
import { logoutConnectedUser } from '../../user/userUtils';
import { SignUpAskPhoneContent } from '../routes/ask-phone/SignUpAskPhoneContent';
import { SignUpConfirmPhoneContent } from '../routes/confirm-phone/SignUpConfirmPhoneContent';
import { doctrineAnalytics } from '../../utils/analyticsUtils';
import { Hyperlink } from '../../components/Hyperlink';
import { buildUrlWithParameters } from '../../utils/url-utils/urlUtils';
import { Modal } from '../../components/modal/Modal';
import { SignUpProvider } from '../routes/SignUpContext';

export const FROM_PHONE_MODAL_TO_SETTINGS_PARAM = 'fromSignUpPhoneModal';

type State = {
  phoneNumber: string;
  isFirstStep: boolean;
};

type Props = {
  closeModal: () => void;
  isOpen: boolean;
};

export class SignUpPhoneModal extends React.Component<Props, State> {
  static defaultProps = {
    closeModal: () => {},
    isOpen: false,
  };

  state: State = {
    phoneNumber: '',
    isFirstStep: true,
  };

  componentDidMount() {
    doctrineAnalytics('Account SignUpAskPhoneModalAppeared');
  }

  getToFirstStep = () => {
    this.setState({ phoneNumber: '', isFirstStep: true });
  };

  saveAndGetToNextStep = (phoneNumber: string) => {
    this.setState({ phoneNumber, isFirstStep: false });
  };

  closeAndReloadPage = () => {
    window.location.reload();
  };

  render() {
    const { isFirstStep } = this.state;
    const { isOpen, closeModal } = this.props;
    return (
      <SignUpProvider>
        <Modal
          isOpen={isOpen}
          onRequestClose={closeModal}
          shouldCloseOnOverlayClick={false}
        >
          {isFirstStep && (
            <div className="signup-phone-modal">
              <SignUpAskPhoneContent
                saveAndGetToNextStep={this.saveAndGetToNextStep}
                source="signup-phone-modal"
              >
                <div className="signup-phone-modal__bottom">
                  <button
                    type="button"
                    className="signup-phone-modal__logout"
                    onClick={logoutConnectedUser}
                  >
                    <FormattedMessage id="signup/signup-phone-modal/SignUpPhoneModal.tsx/1" />
                  </button>
                  <FormattedMessage id="signup/signup-phone-modal/SignUpPhoneModal.tsx/separator" />
                  <Hyperlink
                    href={buildUrlWithParameters('/compte/general', {
                      source: 'signup_phone_modal',
                      [FROM_PHONE_MODAL_TO_SETTINGS_PARAM]: 'true',
                    })}
                    className="signup-phone-modal__logout"
                  >
                    <FormattedMessage id="signup/signup-phone-modal/SignUpPhoneModal.tsx/2" />
                  </Hyperlink>
                </div>
              </SignUpAskPhoneContent>
            </div>
          )}
          {!isFirstStep && (
            <div className="signup-phone-modal center">
              <SignUpConfirmPhoneContent
                phoneNumber={this.state.phoneNumber}
                getToNextStep={this.closeAndReloadPage}
                getToFirstStep={this.getToFirstStep}
                source="signup-phone-modal"
              />
            </div>
          )}
        </Modal>
      </SignUpProvider>
    );
  }
}
